import type { Json } from "@/integrations/supabase/types";

export interface GenerationDetails {
  provider: string | null;
  model: string | null;
  step: string | null;
  model_label: string | null;
  fell_back: boolean;
}

export interface SavedGenerationMetadata extends GenerationDetails {
  image_url: string;
}

export function normalizeGenerationMetadata(
  imageUrl: unknown,
  value: unknown,
): SavedGenerationMetadata | null {
  if (typeof imageUrl !== "string" || !imageUrl) return null;
  if (!value || typeof value !== "object") return null;

  const generation = value as Record<string, unknown>;
  if (typeof generation.model !== "string" || !generation.model) return null;

  return {
    image_url: imageUrl,
    model: generation.model,
    provider: typeof generation.provider === "string" ? generation.provider : null,
    step: typeof generation.step === "string" ? generation.step : null,
    model_label: typeof generation.model_label === "string" ? generation.model_label : null,
    fell_back: generation.fell_back === true,
  };
}

export function parseSavedGenerationMetadata(value: unknown): SavedGenerationMetadata[] {
  if (!Array.isArray(value)) return [];
  return value
    .map((entry) => {
      if (!entry || typeof entry !== "object") return null;
      const item = entry as Record<string, unknown>;
      return normalizeGenerationMetadata(item.image_url, item);
    })
    .filter((entry): entry is SavedGenerationMetadata => entry !== null);
}

export function serializeGenerationMetadata(entries: SavedGenerationMetadata[]): Json {
  return entries.map((entry) => ({
    image_url: entry.image_url,
    provider: entry.provider,
    model: entry.model,
    step: entry.step,
    model_label: entry.model_label,
    fell_back: entry.fell_back,
  }));
}